/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/CustomerLink.js
 */

import React from 'react';
import { Link } from 'react-router-dom';

const getLink = (data) => `/search?query=${data.id}`;

const CustomerLink = ({ data, type }) => {
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <Link className="Link" to={getLink(data)}>
          <div className="Type">Customer</div>
          <div className="Value">{data.name}</div>
        </Link>
      </div>
      <div className="SummaryLink">
        <Link className="Link" to={getLink(data)}>
          {getLink(data)}
        </Link>
      </div>
      <div className="SummaryData">
        <p>Customer Account Id: {data.id}</p>
        <p>
          Customer Account Status: {data.isActive ? 'Active' : 'Not Active'}
        </p>
        <p>Customer is on CUP: {data.isCupUser ? 'Yes' : 'No'}</p>
      </div>
    </div>
  );
};

export default CustomerLink;
